import {Trans} from "@lingui/react/macro";

import Link from "@khanacademy/wonder-blocks-link";
import {LabelSmall} from "@khanacademy/wonder-blocks-typography";
import {toAbsoluteUrl} from "@khan/urls";

const GLOBAL_FREE_TEACHER_TOOLS_TERMS_URL_V2 = toAbsoluteUrl(
    "/about/docs/grassroots-khanmigo-teacher-tools-terms",
);

// Path the the Terms of Service page
const TOS_PATH = "/about/docs/khan-academy-terms-of-service";

// Path to the Privacy Policy page
const PRIVACY_POLICY_PATH = "/about/privacy-policy";

/**
 * Our standard "you agree to" text for when a user logs in.
 */
export function LoginLegalBlurb(): React.ReactNode {
    return (
        <LabelSmall>
            <Trans>
                By logging in, you agree to the{" "}
                <Link href={TOS_PATH} target="_blank">
                    Khan Academy Terms of Service
                </Link>{" "}
                and{" "}
                <Link href={PRIVACY_POLICY_PATH} target="_blank">
                    Privacy Policy
                </Link>
                .
            </Trans>
        </LabelSmall>
    );
}

export function TeacherLoginLegalBlurb(): React.ReactNode {
    const termsUrl = GLOBAL_FREE_TEACHER_TOOLS_TERMS_URL_V2;

    return (
        <LabelSmall>
            <Trans>
                By logging in, you agree to the{" "}
                <Link href={TOS_PATH} target="_blank">
                    Khan Academy Terms of Service
                </Link>
                ,{" "}
                <Link href={termsUrl} target="_blank">
                    Khanmigo Teacher Tools supplement
                </Link>
                , and{" "}
                <Link href={PRIVACY_POLICY_PATH} target="_blank">
                    Privacy Policy
                </Link>
                .
            </Trans>
        </LabelSmall>
    );
}
